// extracted by mini-css-extract-plugin
module.exports = {"banner":"Style_banner__drXNN"};